import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppService } from './app.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './shared/material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, UrlSerializer } from '@angular/router';
import { routing, LowerCaseUrlSerializer } from './app.routes';
import { AppComponent } from './app.component';
import {
  HeaderTopComponent,
  FavoriteDialog
} from './shared/components/header-top/header-top.component';
import { UCInspectionsComponent } from './modules/uc-inspections/uc-inspections.component';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { EquipmentActionsModule } from './shared/components/equipment-actions/equipment-actions.module';
import { RedirectComponent } from './app.routes';
import { UCInspectionsService } from './modules/uc-inspections/uc-inspections.service';
import { TranslateModule, TranslateService } from './translate';
import {
  SetupUndercarriageService,
  SetupUndercarriageOnEquipment,
  SetupUndercarriageComponent,
  SetupUndercarriageInInventory,
  SetupUndercarraigeActionComponent
} from './modules/setup-undercarriage/index';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { LoadingService } from './shared/services/loading.service';
import { ManageEquipmentService } from './modules/manage-equipment/manage-equipment.service';
import { ChangeJobsiteComponent } from './modules/manage-equipment/components/change-jobsite/change-jobsite.component';
import { CustomEvalService } from './modules/CustomEval/custom-eval.service';
import { EquipmentRecordActionService } from './modules/equipment-record-action/equipment-record-action.service';

// Modules
import { SharedModule } from './shared/shared.module';
import { WsreModule } from './modules/wsre/wsre.module';
import { ManageEquipmentComponent } from './modules/manage-equipment/manage-equipment.component';
import { InterpretationModule } from './modules/interpretation/interpretation.module';
import { SetupEquipmentModule } from './modules/setup-equipment/setup-equipment.module';
import { EditPhotoComponent } from './shared/components/edit-photo/edit-photo.component';
import { EditPhotoTestComponent } from './shared/components/edit-photo-test/edit-photo-test.component';
import { RopeShovelModule } from './modules/rope-shovel/rope-shovel.module';
import { BarGraphService } from './modules/interpretation/bar-graph.service';
import { PreferencesModule } from './modules/preferences/preferences.module';
import { InspectionModule } from './modules/inspection/inspection.module';
import { ThermorgraphyInspectionModule } from './modules/Thermography/thermorgraphy-inspection.module';
import { UserService } from './shared/services/user.service';
import { EmailFaxLogService } from './../app/modules/GET_NEW_UI/emailfaxlog/email-fax-log.service';
import { ChangeMeterUnitComponent } from './modules/manage-equipment/components/change-meter-unit/change-meter-unit.component';
import { UpdateMeterComponent } from './modules/manage-equipment/components/update-meter/update-meter.component';
import {
  CreateMeasurementPointsComponentComponent
} from './modules/measurement-points-admin/create-measurement-points-component/create-measurement-points-component.component';
import {
  EditMeasurementPointsComponentComponent
} from './modules/measurement-points-admin/edit-measurement-points-component/edit-measurement-points-component.component';
import { InspectionPlannerComponent } from './modules/manage-equipment/components/inspection-planner/inspection-planner.component';
import {
  UpdateInspectionForecastingComponent
} from './modules/manage-equipment/components/update-inspection-forecasting/update-inspection-forecasting.component';
import { MeasurementPonitsService } from './modules/measurement-points-admin/services/measurement-points-service';
import { MeasurementPointsAdminModule } from './modules/measurement-points-admin/measurement-points-admin.module';
import {
  WidgetsEnlargedComponentComponent
} from './modules/widgets/components/widgets-enlarged-component/widgets-enlarged-component.component';
import { InventoryModule } from './modules/inventory/inventory.module';
import { ActionModule } from './modules/action/action-module';
import { ManageComponentsModule } from './modules/manage-components/manage-components.module';
import { ComponentForecastModule } from './modules/component-forecast/component-forecast.module';
import { SetupFamilyModule } from './modules/setup-family/setup-family.module';
import { SetupModelsModule } from './modules/setup-models/setup-models.module';
import { AboutPopupComponent } from './modules/about-popup/about-popup.component';
import { CustomerNotesModule } from './modules/customer-notes/customer-notes.module';
import { CustomErrorHandlers } from './shared/CustomErrorHandlers';
import { CreateNewTemperatureInspectionComponent } from './modules/Temperature/create-new-temperature-inspection/create-new-temperature-inspection.component';
import { TemperatureInspectionService } from './modules/Temperature/temperature-inspection.service';
import { InterpTemperatureInspectionComponent } from './modules/Temperature/interp-temperature-inspection/interp-temperature-inspection.component';
import { AddTemInspectionCommentComponent } from './modules/Temperature/add-tem-inspection-comment/add-tem-inspection-comment.component';
import { AddTempInspectionDetailsCommentComponent } from './modules/Temperature/add-temp-inspection-details-comment/add-temp-inspection-details-comment.component';
import { UpdateAmbienttempInspectionDateDialogComponent } from './modules/Temperature/update-ambienttemp-inspection-date-dialog/update-ambienttemp-inspection-date-dialog.component';
import { TemperatureInspectionHistoryDialogComponent } from './modules/Temperature/temperature-inspection-history-dialog/temperature-inspection-history-dialog.component';
import { CreateDialogThermographyComponent } from './modules/Thermography/create-dialog-thermography/create-dialog-thermography.component';
import { AddThermographyInspectionDetailsCommentComponent } from './modules/Thermography/create-new-thermography-inspection/add-temp-inspection-details-comment/add-thermography-inspection-details-comment';
import { ManageCustomEvalComponent } from './modules/CustomEval/Page/manage-custom-eval.component';

//import { SetupUndercarraigeActionComponent } from './modules/setup-undercarriage/setup-undercarraige-action/setup-undercarraige-action.component';
// import * as Charts from 'fusioncharts/fusioncharts.charts';
// import { FusionChartsModule } from 'angular-fusioncharts';
// import FusionCharts from 'fusioncharts';
// import Column2D from 'fusioncharts/viz/column2d';
// import doughnut3d from 'fusioncharts/viz/doughnut3d';
// import msarea from 'fusioncharts/viz/msarea';
// import stackedcolumn2d from 'fusioncharts/viz/stackedcolumn2d';
// import msstackedcolumn2d from 'fusioncharts/viz/msstackedcolumn2d';
// //import FusionTheme from 'fusioncharts/themes/es/fusioncharts.theme.fusion';
// import scrollstackedcolumn2d from 'fusioncharts/viz/scrollstackedcolumn2d';
// import ZuneTheme from 'fusioncharts/themes/es/fusioncharts.theme.zune';
// import msspline from 'fusioncharts/viz/msspline';
// import inversemsline from 'fusioncharts/viz/inversemsline';
// //import * as FusionCharts from 'fusioncharts';
// import * as FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
// FusionChartsModule.fcRoot( FusionCharts, FusionTheme,stackedcolumn2d, Column2D, doughnut3d, msarea, ZuneTheme, msstackedcolumn2d, inversemsline,scrollstackedcolumn2d, msspline );


import * as FusionCharts from "fusioncharts";
import * as Charts from "fusioncharts/fusioncharts.charts";
import * as FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import { FusionChartsModule } from "angular-fusioncharts";
import { InspectionHistoryComponent } from './modules/manage-equipment/components/inspection-history/inspection-history.component';
import { CustomEvalDeleteConfirmComponent } from './modules/CustomEval/Components/custom-eval-delete-confirm/custom-eval-delete-confirm.component';

import { ActionHistoryComponent } from './modules/manage-equipment/components/action-history/action-history.component';
import { TrackFrameConfigurationComponent } from './modules/manage-equipment/components/track-frame-configuration/track-frame-configuration.component';
import { FrameConfigWarningComponent } from './modules/interpretation/components/frame-config-warning/frame-config-warning.component';
import { WsreSendReportComponent } from './modules/wsre/components/wsre-send-report/wsre-send-report.component';
import { SetupTrainingTypesComponent } from './modules/Training/setup-training-types/setup-training-types.component';
import { AddTrainingCategoryComponent } from './modules/Training/add-training-category/add-training-category.component';
import { TrainingService } from './modules/Training/training.service';
import { SetupTrainingComponent } from './modules/Training/setup-training/setup-training.component';
import { AddSlideComponent } from './modules/Training/add-slide/add-slide.component';
import { SetupTrainingQuestionsComponent } from './modules/Training/setup-training-questions/setup-training-questions.component';
import { AddTrainingQuestionComponent } from './modules/Training/add-training-question/add-training-question.component';
import { ManageTrainingActivityComponent } from './modules/Training/manage-training-activity/manage-training-activity.component';
import { StartTrainingDetailsComponent } from './modules/Training/start-training-details/start-training-details.component';
import { SendTrainingPopupComponent } from './modules/Training/send-training-popup/send-training-popup.component';
import { TrainingSessionComponent } from './modules/Training/training-session/training-session.component';
import { InspectionNoteComponent } from './modules/manage-equipment/components/inspection-note/inspection-note.component';
import { ManageComponentCriticalityComponent } from './modules/manage-component-criticality/manage-component-criticality.component';
import { ComponentLifePerformanceComponent } from './modules/component-life-performance/component-life-performance.component';
import { ObservationpointHistoryComponent } from './modules/manage-equipment/components/observationpoint-history/observationpoint-history.component';
import { ConfirmDialogComponent } from './modules/interpretation/components/confirm-dialog/confirm-dialog.component';
import { EquipmentRecordActionComponent } from './modules/equipment-record-action/equipment-record-action.component';
import { CustomerContactComponent } from './modules/customer-contact/customer-contact.component';
import { AddNewUserClComponent } from './modules/customer-contact/add-new-user-cl/add-new-user-cl.component';
import { AddNewUserElComponent } from './modules/customer-contact/add-new-user-el/add-new-user-el.component';
import { AddNewUserJslComponent } from './modules/customer-contact/add-new-user-jsl/add-new-user-jsl.component';
import { CustomerContactService } from './modules/customer-contact/add-new-user-cl/customer-contact.service';
import { CalculateActionWornComponent } from './modules/equipment-record-action/component/calculate-action-worn/calculate-action-worn.component';
import { ActionCommentComponent } from './modules/equipment-record-action/component/action-comment/action-comment.component';
import { JobrolePermissionsComponent } from './modules/jobrole-permissions/jobrole-permissions.component';
import { EditSystemSerialNumberComponent } from './modules/interpretation/components/edit-system-serial-number/edit-system-serial-number.component';
import { SetupEquipmentTestComponent } from './modules/setup-equipment-test/setup-equipment-test.component';

//NEW GET UI COMPONENTS
import { DashboardComponentGET } from './modules/GET_NEW_UI/dashboard/dashboard.component';
import { EnterSafetyInspectionDialogComponent } from './modules/GET_NEW_UI/enter-safety-inspection-dialog/enter-safety-inspection-dialog.component';
import { ConfigAddTakeComponent } from './modules/GET_NEW_UI/config-add-take/config-add-take.component';
import { ConfigAddToolboxTalkComponent } from './modules/GET_NEW_UI/config-add-toolbox-talk/config-add-toolbox-talk.component';
import { ConfigAddMontlyDashbrdMessageComponent } from './modules/GET_NEW_UI/config-add-montly-dashbrd-message/config-add-montly-dashbrd-message.component';
import { AnswerSetupInductionQuestionComponent } from './modules/GET_NEW_UI/setup-induction-question/answer-setup-induction-question/answer-setup-induction-question.component';
import { EditSetupInductionQuestionComponent } from './modules/GET_NEW_UI/setup-induction-question/edit-setup-induction-question/edit-setup-induction-question.component';
import { EditSetupDepComponent } from './modules/GET_NEW_UI/config-setup-department/edit-setup-dep/edit-setup-dep.component';
import { MonthlyAlertDialogComponent } from './modules/GET_NEW_UI/config-add-montly-dashbrd-message/monthly-alert-dialog/monthly-alert-dialog.component';
import { ConfigSetupChecklistAddNewCategoryDialogComponent } from './modules/GET_NEW_UI/config-setup-checklist/config-setup-checklist-add-new-category-dialog/config-setup-checklist-add-new-category-dialog.component';
import { ConfigSetupChecklistAddNewQuestionDialogComponent } from './modules/GET_NEW_UI/config-setup-checklist/config-setup-checklist-add-new-question-dialog/config-setup-checklist-add-new-question-dialog.component';
import { ConfigSetupChecklistEditCategoryDialoglogComponent } from './modules/GET_NEW_UI/config-setup-checklist/config-setup-checklist-edit-category-dialoglog/config-setup-checklist-edit-category-dialoglog.component';
import { AddDepartmentDialogComponent } from './modules/GET_NEW_UI/config-setup-department/add-department-dialog/add-department-dialog.component';
import { AddWorkareaDialogComponent } from './modules/GET_NEW_UI/config-setup-department/add-workarea-dialog/add-workarea-dialog.component';
import { EditWorkareaDialogComponent } from './modules/GET_NEW_UI/config-setup-department/edit-workarea-dialog/edit-workarea-dialog.component';
import { AddInductionTypesComponent } from './modules/GET_NEW_UI/config-setup-inductionand-sections/components/add-induction-types/add-induction-types.component';
import { DialogAddSectionComponent } from './modules/GET_NEW_UI/config-setup-inductionand-sections/components/dialog-add-section/dialog-add-section.component';
import { AddInductionQuestionComponent } from './modules/GET_NEW_UI/setup-induction-question/component/add-induction-question/add-induction-question.component';
import { DialogAddSlideComponent } from './modules/GET_NEW_UI/setup-induction-slides/component/dialog-add-slide/dialog-add-slide.component';
import { AddRepairerWorkshopModalComponent } from './modules/GET_NEW_UI/add-repairer-workshop-modal/add-repairer-workshop-modal.component';
import { AttachImplementModalComponent } from './modules/GET_NEW_UI/attach-implement-modal/attach-implement-modal.component';
import { ChangeImplementJobsiteModalComponent } from './modules/GET_NEW_UI/change-implement-jobsite-modal/change-implement-jobsite-modal.component';
import { ClearFlagDialogComponent } from './modules/GET_NEW_UI/digital-form-fill/component/clear-flag-dialog/clear-flag-dialog.component';
import { CopyDigitaFormComponent } from './modules/GET_NEW_UI/digital-form-fill/component/copy-digital-form/copy-digital-form.component';
import { EditPhotoDigitalComponent } from './modules/GET_NEW_UI/digital-form-fill/component/edit-photo-digital/edit-photo-digital.component';
import { FlagCommentComponent } from './modules/GET_NEW_UI/digital-form-fill/component/flag-comment/flag-comment.component';
import { NormalQuestionHistoryComponent } from './modules/GET_NEW_UI/digital-form-fill/component/normal-question-history/normal-question-history.component';
import { SelectEquipmentComponent } from './modules/GET_NEW_UI/digital-form-fill/component/select-equipment/select-equipment.component';
import { StructuralQuestionHistoryComponent } from './modules/GET_NEW_UI/digital-form-fill/component/structural-question-history/structural-question-history.component';
import { ImplementActionComponent } from './modules/GET_NEW_UI/equipment-details/components/implement-action/implement-action.component';
import { ImplementRebuildCompleteDialogComponent } from './modules/GET_NEW_UI/equipment-details/components/implement-rebuild-complete-dialog/implement-rebuild-complete-dialog.component';
import { ImplementRebuildDialogComponent } from './modules/GET_NEW_UI/equipment-details/components/implement-rebuild-dialog/implement-rebuild-dialog.component';
import { ImplementSortComponent } from './modules/GET_NEW_UI/equipment-details/components/implement-sort/implement-sort.component';
import { ImplementTargetsUpdateComponent } from './modules/GET_NEW_UI/equipment-details/components/implement-targets-update/implement-targets-update.component';
import { MoveToInventoryComponent } from './modules/GET_NEW_UI/equipment-details/components/move-to-inventory/move-to-inventory.component';
import { PerformInspectionComponent } from './modules/GET_NEW_UI/equipment-details/components/perform-inspection/perform-inspection.component';
import { FavouriteDialogComponent } from './modules/GET_NEW_UI/favourite-dialog/favourite-dialog.component';
import { AddFecrRecommendationComponent } from './modules/GET_NEW_UI/FECR/add-fecr-recommendation/add-fecr-recommendation.component';
import { FecrMovetoInventoryComponent } from './modules/GET_NEW_UI/FECR/fecr-moveto-inventory/fecr-moveto-inventory.component';
import { FecrPartsListComponent } from './modules/GET_NEW_UI/FECR/fecr-parts-list/fecr-parts-list.component';
import { FecrProjectContactDialogComponent } from './modules/GET_NEW_UI/FECR/fecr-project-contact-dialog/fecr-project-contact-dialog.component';
import { FECRDashboardComponent } from './modules/GET_NEW_UI/FECR/FECRDashboard/dashboard/fecr-dashboard.component';
import { MoveImplementToRepairerComponent } from './modules/GET_NEW_UI/FECR/move-implement-to-repairer/move-implement-to-repairer.component';
import { ImplementStatusModalComponent } from './modules/GET_NEW_UI/implement-status-modal/implement-status-modal.component';
import { RecordRepairModalComponent } from './modules/GET_NEW_UI/record-repair-modal/record-repair-modal.component';
import { RecordReplaceModalComponent } from './modules/GET_NEW_UI/record-replace-modal/record-replace-modal.component';
import { RemoveImplementModalComponent } from './modules/GET_NEW_UI/remove-implement-modal/remove-implement-modal.component';
import { SchematicViewComponent } from './modules/GET_NEW_UI/schematic-view/schematic-view.component';
import { SelectionNewImplementComponent } from './modules/GET_NEW_UI/setup-implement/add-new-componentType/add-new-componentType.component';
import { CopyImplementDialogComponent } from './modules/GET_NEW_UI/setup-implement/copy-implement-dialog/copy-implement-dialog.component';
import { GETDeleteConfirmationDialogComponent } from './modules/GET_NEW_UI/setup-implement/delete-confirmation-dialog/delete-confirmation-dialog.component';
import { GETViewPhotoComponent } from './modules/GET_NEW_UI/shared/view-photo/view-photo.component';
import { GETEditDataComponent } from './modules/GET_NEW_UI/shared/edit-data/edit-data.component';

import { AboutComponent } from './modules/GET_NEW_UI/about/about.component';
import { AddObservationPointComponent } from './modules/GET_NEW_UI/add-observation-point/add-observation-point.component';
import { DialogDraggableTitleDirective } from './modules/GET_NEW_UI/add-observation-point/dialog-draggable-title.directive';
import { BreadCrumbTopComponent } from './modules/GET_NEW_UI/breadcrumb-top/breadcrumb-top.component';
import { ConfigSetupChecklistComponent } from './modules/GET_NEW_UI/config-setup-checklist/config-setup-checklist.component';
import { ConfigSetupDepartmentComponent } from './modules/GET_NEW_UI/config-setup-department/config-setup-department.component';
import { ConfigSetupFormsComponent } from './modules/GET_NEW_UI/config-setup-forms/config-setup-forms.component';
import { ConfigSetupIncidentComponent } from './modules/GET_NEW_UI/config-setup-incident/config-setup-incident.component';
import { ConfigSetupInductionandSectionsComponent } from './modules/GET_NEW_UI/config-setup-inductionand-sections/config-setup-inductionand-sections.component';
import { ConfigViewEditMonHrsComponent } from './modules/GET_NEW_UI/config-view-edit-mon-hrs/config-view-edit-mon-hrs.component';
import { CopyImplementComponent } from './modules/GET_NEW_UI/copy-implement/copy-implement.component';
import { ImplementLocationHistoryComponent } from './modules/GET_NEW_UI/dashboard/implement-location-history/implement-location-history.component';
import { ImplementOverviewComponent } from './modules/GET_NEW_UI/dashboard/implement-overview/implement-overview.component';
import { ImplementsByEquipmentComponent } from './modules/GET_NEW_UI/dashboard/implements-by-equipment/implements-by-equipment.component';
import { SearchPanelComponent } from './modules/GET_NEW_UI/dashboard/search-panel/search-panel.component';
import { DigitalFormCategorylistComponent } from './modules/GET_NEW_UI/digital-form-fill/component/digital-form-categorylist/digital-form-categorylist.component';
import { DigitalFormSectionQuestionsComponent } from './modules/GET_NEW_UI/digital-form-fill/component/digital-form-section-questions/digital-form-section-questions.component';
import { DigitalFormFillComponent } from './modules/GET_NEW_UI/digital-form-fill/digital-form-fill.component';
import { DigitalFormSearchAdminstartionComponent } from './modules/GET_NEW_UI/digital-form-search-adminstartion/digital-form-search-adminstartion.component';
import { DigitalFormSearchComponent } from './modules/GET_NEW_UI/digital-form-search/digital-form-search.component';
import { DraggableSchematicComponent } from './modules/GET_NEW_UI/draggable-schematic/draggable-schematic.component';
import { ImplementHistoryComponent } from './modules/GET_NEW_UI/entities/implement-history/implement-history.component';
import { EquipmentDetailsComponent } from './modules/GET_NEW_UI/equipment-details/equipment-details.component';
import { ImplementDetailsHeaderComponent } from './modules/GET_NEW_UI/equipment-details/implement-details-header/implement-details-header.component';
import { ObservationDetailsComponent } from './modules/GET_NEW_UI/equipment-details/observation-details/observation-details.component';
import { SchematicObservationPointsComponent } from './modules/GET_NEW_UI/equipment-details/schematic-observation-points/schematic-observation-points.component';
import { FecrImplementDetailsHeaderComponent } from './modules/GET_NEW_UI/FECR/fecr-implement-details-header/fecr-implement-details-header.component';
import { GETFecrImplementRebuildDetailsComponent } from './modules/GET_NEW_UI/FECR/fecr-implement-rebuild-details/fecr-implement-rebuild-details.component';
import { FecrObservationDetailsComponent } from './modules/GET_NEW_UI/FECR/fecr-observation-details/fecr-observation-details.component';
import { FecrObservationHistoryComponent } from './modules/GET_NEW_UI/FECR/fecr-observation-history/fecr-observation-history.component';
import { FecrImplmentSearchResultComponent } from './modules/GET_NEW_UI/FECR/FECRDashboard/fecr-implment-search-result/fecr-implment-search-result.component';
import { FecrSearchPanelComponent } from './modules/GET_NEW_UI/FECR/FECRDashboard/fecr-search-panel/fecr-search-panel.component';
import { HomeComponent } from './modules/GET_NEW_UI/home/home.component';
import { ImplementDetailsComponent } from './modules/GET_NEW_UI/implement-details/implement-details.component';
import { ImplementTemplateSetupComponent } from './modules/GET_NEW_UI/implement-template-setup/implement-template-setup.component';
import { ImplementTemplatesComponent } from './modules/GET_NEW_UI/implement-templates/implement-templates.component';
import { LoginComponent } from './modules/GET_NEW_UI/login/login.component';
import { NavbarSide } from './modules/GET_NEW_UI/navbar-side/navbar-side.component';
import { NavbarTopComponent } from './modules/GET_NEW_UI/navbar-top/navbar-top.component';
import { OnBoardingSetupInductionQuestionComponent } from './modules/GET_NEW_UI/on-boarding-setup-induction-question/on-boarding-setup-induction-question.component';
import { PerformInductionComponent } from './modules/GET_NEW_UI/perform-induction/perform-induction.component';
import { FilterPipe } from './modules/GET_NEW_UI/pipes/filter.pipe';
import { PreferencesComponent } from './modules/GET_NEW_UI/preferences/preferences.component';
import { SafetyInductionSetupComponent } from './modules/GET_NEW_UI/safety-induction-setup/safety-induction-setup.component';
import { SchemanticOpPopupComponent } from './modules/GET_NEW_UI/schemantic-op-popup/schemantic-op-popup.component';
import { SearchFormAnalysisreportingComponent } from './modules/GET_NEW_UI/search-form-analysisreporting/search-form-analysisreporting.component';
import { SearchInductionComponent } from './modules/GET_NEW_UI/search-induction/search-induction.component';
import { SearchSafetyInspectionComponent } from './modules/GET_NEW_UI/search-safety-inspection/search-safety-inspection.component';
import { SelectAFormComponent } from './modules/GET_NEW_UI/select-a-form/select-a-form.component';
import { ApplySelectionComponent } from './modules/GET_NEW_UI/setup-implement/apply-selection/apply-selection.component';
import { SetupImplementComponent } from './modules/GET_NEW_UI/setup-implement/setup-implement.component';
import { AddQuestionInducComponent } from './modules/GET_NEW_UI/setup-induction-question/add-question-induc/add-question-induc.component';
import { SetupInductionQuestionComponent } from './modules/GET_NEW_UI/setup-induction-question/setup-induction-question.component';
import { SetupInductionSlidesComponent } from './modules/GET_NEW_UI/setup-induction-slides/setup-induction-slides.component';
import { CarouselItemDirective } from './modules/GET_NEW_UI/shared/carousel/carousel-item.directive';
import { CarouselComponent, CarouselItemElement } from './modules/GET_NEW_UI/shared/carousel/carousel.component';
import { UploadFormComponent } from './modules/GET_NEW_UI/upload-form/upload-form.component';
//import { MatAutocompleteModule, MatButtonModule, MatButtonToggleModule, MatCardModule, MatCheckboxModule, MatChipsModule, MatDatepickerModule, MatDialog, MatDialogModule, MatDialogRef, MatFormFieldModule, MatGridListModule, MatIconModule, MatInputModule, MatListModule, MatMenuModule, MatNativeDateModule, MatProgressBarModule, MatProgressSpinnerModule, MatRadioModule, MatSelectModule, MatSlideToggleModule, MatSnackBarModule, MatTableModule, MatTabsModule, MatToolbarModule, MatTooltipModule, MAT_DIALOG_DATA } from '@angular/material';
import { GETDashboardService } from './modules/GET_NEW_UI/dashboard/dashboard.service';
import { AttachImplementModalService } from './modules/GET_NEW_UI/attach-implement-modal/attach-implement-modal.service';
import { ChangeImplementJobsiteModalService } from './modules/GET_NEW_UI/change-implement-jobsite-modal/change-implement-jobsite-modal.service';
import { DigitalFormService } from './modules/GET_NEW_UI/digital-form-fill/digital-form.service';
import { EquipmentDetailsService } from './modules/GET_NEW_UI/equipment-details/equipment-details.service';
import { FavouriteDialogService } from './modules/GET_NEW_UI/favourite-dialog/favourite-dialog.service';
import { ImplementRebuildService } from './modules/GET_NEW_UI/FECR/fecr-implement-rebuild-details/implement-rebuild.service';
import { FrontEndComponetService } from './modules/GET_NEW_UI/FECR/front-end-componet.service';
import { ImplementDetailsService } from './modules/GET_NEW_UI/implement-details/implement-details.service';
import { ImplementStatusModalService } from './modules/GET_NEW_UI/implement-status-modal/implement-status-modal.service';
import { RemoveImplementModalService } from './modules/GET_NEW_UI/remove-implement-modal/remove-implement-modal.service';
import { SchematicViewService } from './modules/GET_NEW_UI/schematic-view/schematic-view.service';
import { CustomerService } from './modules/GET_NEW_UI/services/customer.service';
import { EquipmentService } from './modules/GET_NEW_UI/services/equipment.service';
import { ImplementTemplateService } from './modules/GET_NEW_UI/services/implement-template.service';
import { SafetyConfigService } from './modules/GET_NEW_UI/services/safety-config.service';
import { SafetyInductionService } from './modules/GET_NEW_UI/services/safety-induction.service';
import { SetupImplementService } from './modules/GET_NEW_UI/setup-implement/setup-implement.service';
import { GETInventoryService } from './modules/GET_NEW_UI/services/inventory.service';
import { GETPreferencesService } from './modules/GET_NEW_UI/preferences/preferences.service';
import { GETSetupEquipmentService } from './modules/GET_NEW_UI/setup-equipment/setup-equipment.service';
import { HttpModule } from '@angular/http';
import { AngularDualListBoxModule } from 'angular-dual-listbox';
import { UiSwitchModule } from 'ngx-toggle-switch';
import { ToastrModule } from 'ngx-toastr';
import { GETAboutPopupComponent } from './modules/GET_NEW_UI/about-popup/about-popup.component';
import { GETUpdateMeterComponent } from './modules/GET_NEW_UI/equipment-details/components/update-meter/get-update-meter.component';
import { GETChangeJobsiteComponent } from './modules/GET_NEW_UI/equipment-details/components/change-jobsite/change-jobsite.component';
import { GETChangeMeterUnitComponent } from './modules/GET_NEW_UI/equipment-details/components/change-meter-unit/change-meter-unit.component';
import { GETEditPhotoComponent } from './modules/GET_NEW_UI/shared/edit-photo/edit-photo.component';
import { GETInspectionPlannerComponent } from './modules/GET_NEW_UI/equipment-details/components/inspection-planner/inspection-planner.component';
import { GETSetupEquipmentComponent } from './modules/GET_NEW_UI/setup-equipment/setup-equipment.component';
import { GETSharedModule } from './modules/GET_NEW_UI/shared/shared.module';
import { GETInspectionModule } from './modules/GET_NEW_UI/inspections/inspection.module';
import { DigitalFormNewInspectionComponent } from './modules/GET_NEW_UI/digital-form-new-inspection/digital-form-new-inspection.component';
import { ChangeCrackStatusComponent } from './modules/GET_NEW_UI/equipment-details/components/change-crack-status/change-crack-status.component';
import { InventoryOrWsreDialogComponent } from './modules/inventory/inventory-or-wsre-dialog/inventory-or-wsre-dialog.component';
import { DeleteConfirmDigilatFormDialogComponent } from './modules/GET_NEW_UI/digital-form-fill/component/delete-confirm-dialog/delete-confirm-dialog.component';
import { DialogFindAttendeeComponent } from './modules/GET_NEW_UI/perform-induction/components/dialog-find-attendee/dialog-find-attendee.component';
import { DialogAddAttendeeComponent } from './modules/GET_NEW_UI/perform-induction/components/dialog-add-attendee/dialog-add-attendee.component';
import { StartInductionComponent } from './modules/GET_NEW_UI/start-induction/start-induction.component';
import { SafetyObservationDashboardComponent } from './modules/GET_NEW_UI/safety-observation-dashboard/safety-observation-dashboard.component';
import { SafetyGeneraldashboardService } from './modules/GET_NEW_UI/services/safety-generaldashboard.service';
import { SafetyIndicatorsComponent } from './modules/GET_NEW_UI/safety-indicators/safety-indicators.component';
import { SafetyGeneralDashboardComponent } from './modules/GET_NEW_UI/SafetyAnalysisReport/safety-general-dashboard/safety-general-dashboard.component';
import { EnterSafetyInspectionDashboardComponent } from './modules/GET_NEW_UI/enter-safety-inspection-dashboard/enter-safety-inspection-dashboard.component';
import { AddCommentDialogComponent } from './modules/GET_NEW_UI/enter-safety-inspection-dashboard/add-comment-dialog/add-comment-dialog.component';
import { AddImageDialogComponent } from './modules/GET_NEW_UI/enter-safety-inspection-dashboard/add-image-dialog/add-image-dialog.component';
import { ContractorsInvolvedDialogComponent } from './modules/GET_NEW_UI/enter-safety-inspection-dashboard/contractors-involved-dialog/contractors-involved-dialog.component';
import { PersonsInvolvedDialogComponent } from './modules/GET_NEW_UI/enter-safety-inspection-dashboard/persons-involved-dialog/persons-involved-dialog.component';
import { EditWorkAreaDepartmentDialogComponent } from './modules/GET_NEW_UI/enter-safety-inspection-dashboard/edit-work-area-department-dialog/edit-work-area-department-dialog.component';
import { DialogEditDetailsComponent } from './modules/GET_NEW_UI/config-setup-forms/Components/dialog-edit-details/dialog-edit-details.component';
import { DialogAddFormComponent } from './modules/GET_NEW_UI/config-setup-forms/Components/dialog-add-form/dialog-add-form.component';
import { CreateSafetyDigitalFormComponent } from './modules/GET_NEW_UI/create-safety-digital-form/create-safety-digital-form.component';
import { AddIncidenttypeDialogComponent } from './modules/GET_NEW_UI/config-setup-incident/add-incidenttype-dialog/add-incidenttype-dialog.component';
import { EditIncidentTtypeDialogComponent } from './modules/GET_NEW_UI/config-setup-incident/edit-incident-ttype-dialog/edit-incident-ttype-dialog.component';
import { ConfigSetupChecklistEditQuestionDialogComponent } from './modules/GET_NEW_UI/config-setup-checklist/config-setup-checklist-edit-question-dialog/config-setup-checklist-edit-question-dialog.component';
import { DialogAddQuestionComponent } from './modules/GET_NEW_UI/create-safety-digital-form/Components/dialog-add-question/dialog-add-question.component';
import { DialogSetupAnswersComponent } from './modules/GET_NEW_UI/create-safety-digital-form/Components/dialog-setup-answers/dialog-setup-answers.component';
import { DealergroupBrandingComponent } from './modules/dealergroup-branding/dealergroup-branding.component';
import { SafetyFormsService } from './modules/GET_NEW_UI/services/safety-forms.service';
import { UploadDigitalFormsComponent } from './modules/GET_NEW_UI/upload-digital-forms/upload-digital-forms.component';
import { EditImageDialogComponent } from './modules/GET_NEW_UI/upload-digital-forms/edit-image-dialog/edit-image-dialog.component';
import { ConfirmActionBackInComponent } from './modules/equipment-record-action/component/confirm-action-back-in/confirm-action-back-in.component';
import { EditDigitalFormsComponent } from './modules/GET_NEW_UI/edit-digital-forms/edit-digital-forms.component';
import { EditImageDialogEditformsComponent } from './modules/GET_NEW_UI/edit-digital-forms/edit-image-dialog-editforms/edit-image-dialog-editforms.component';
import { UploadFormEditComponent } from './modules/GET_NEW_UI/upload-form-edit/upload-form-edit.component';
import { DialogAddFormCatrgoryComponent } from './modules/GET_NEW_UI/config-setup-forms/Components/dialog-add-form-catrgory/dialog-add-form-catrgory.component';
import { EditCommentDialogComponent } from './modules/GET_NEW_UI/upload-digital-forms/edit-comment-dialog/edit-comment-dialog.component';
import { DigitalEditCommentDialogComponent } from './modules/GET_NEW_UI/edit-digital-forms/digital-edit-comment-dialog/digital-edit-comment-dialog.component';
import { WsreSearchOnEquipmentComponent } from './modules/wsre-search-on-equipment/wsre-search-on-equipment.component';
import { SetupWornLimitComponent } from './modules/setup-worn-limit/setup-worn-limit.component';
import { UcSetupWornLimitService } from './modules/setup-worn-limit/uc-setup-worn-limit.service';
import { UserContactComponent } from './modules/user-contact/user-contact.component';
import { AddNewUserUcComponent } from './modules/user-contact/add-new-user-uc/add-new-user-uc.component';
import { AddNewJobsiteUcComponent } from './modules/user-contact/add-new-jobsite-uc/add-new-jobsite-uc.component';
import { AddNewEquipmentUcComponent } from './modules/user-contact/add-new-equipment-uc/add-new-equipment-uc.component';
import { InspectionReportingModuleComponent } from './modules/inspection-reporting-module/inspection-reporting-module.component';
import { ReportContactDialogComponent } from './modules/inspection-reporting-module/report-contact-dialog/report-contact-dialog.component';
import { AddAdditionalAttachmentComponent } from './modules/inspection-reporting-module/add-additional-attachment/add-additional-attachment.component';
import { FormActivitiesComponent } from './modules/GET_NEW_UI/SafetyAnalysisReport/form-activities/form-activities.component';
import { WsreQuickIdlerComponent } from './modules/wsre-quick-idler/wsre-quick-idler.component';
import { UscoDataComparisonDialogComponent } from './modules/manage-components/usco-data-comparison-dialog/usco-data-comparison-dialog.component';
import { EquipmentStatusPopupComponent } from './modules/equipment-status-popup/equipment-status-popup.component';
import { CustomCommentPopupComponent } from './modules/wsre/components/custom-comment-popup-component/custom-comment-popup.component';
import { InterpretationreportService } from './modules/inspection-reporting-module/interpretationreport.service';
import { ComponentActionHistoryComponent } from './modules/component-life-performance/components/component-action-history/component-action-history.component';
import { SendHirereportDialogComponent } from './modules/inspection-reporting-module/send-hirereport-dialog/send-hirereport-dialog.component';
import { ComponentHistroyDialogComponent } from './modules/GET_NEW_UI/dashboard/implements-by-equipment/components/component-histroy-dialog/component-histroy-dialog.component';
import { AddCrackObsPointDialogComponent } from './modules/GET_NEW_UI/add-crack-obs-point-dialog/add-crack-obs-point-dialog.component';
import { AddAdditionalAttachmentGETComponent } from './modules/inspection-reporting-module/add-additional-attachment-get/add-additional-attachment-get.component';
import { ObspointActionHistroyComponent } from './modules/GET_NEW_UI/equipment-details/components/obspoint-action-histroy/obspoint-action-histroy.component';
import { ImplementDetailsHistoryComponent } from './modules/GET_NEW_UI/implement-details-history/implement-details-history.component';
import { SchemanticOpPopupEditComponent } from './modules/GET_NEW_UI/schemantic-op-popup-edit/schemantic-op-popup-edit.component';
import { IncidentDialogComponent } from './modules/GET_NEW_UI/SafetyAnalysisReport/incident-dialog/incident-dialog.component';
import { IncidentLtiDialogComponent } from './modules/GET_NEW_UI/SafetyAnalysisReport/incident-lti-dialog/incident-lti-dialog.component';
import { IncidentMtiDialodComponent } from './modules/GET_NEW_UI/SafetyAnalysisReport/incident-mti-dialod/incident-mti-dialod.component';
import { HomeNewComponent } from './modules/GET_NEW_UI/home-new/home-new.component';
import { HomescreenSafetyComponent } from './modules/GET_NEW_UI/homescreen-safety/homescreen-safety.component';
import { BucketperformanceAgainstBudgetWidgetComponent } from './modules/GET_NEW_UI/dashboard/bucketperformance-against-budget-widget/bucketperformance-against-budget-widget.component';
import { FecrPrePostShipmentObservationListComponent } from './modules/GET_NEW_UI/FECR/fecr-pre-post-shipment-observation-list/fecr-pre-post-shipment-observation-list.component';
import { FecrAddNewPrepostShipmentObservationComponent } from './modules/GET_NEW_UI/FECR/fecr-add-new-prepost-shipment-observation/fecr-add-new-prepost-shipment-observation.component';
import { FecrNewPrePostShipmentInspectionComponent } from './modules/GET_NEW_UI/FECR/fecr-new-pre-post-shipment-inspection/fecr-new-pre-post-shipment-inspection.component';
import { CopyImplmentAdvancedComponent } from './modules/GET_NEW_UI/copy-implment-advanced/copy-implment-advanced.component';
import { MeasurementPointsDetailComponent } from './modules/measurement-points-admin/measurement-points-detail/measurement-points-detail.component';
import { ConfirmationMessageDeleteormsComponent } from './modules/GET_NEW_UI/upload-form-edit/confirmation-message-deleteorms/confirmation-message-deleteorms.component';
import { GETWidgetsModule } from './modules/GET_NEW_UI/get-widget/get-widgets.module';
import { EnlargeGetDashboardWidgetComponent } from './modules/GET_NEW_UI/get-widget/components/enlarge-get-dashboard-widget/enlarge-get-dashboard-widget.component';
import { WsreQuickFrameComponent } from './modules/wsre-quick-frame/wsre-quick-frame.component';
import { DfiImplementDetailsComponent } from './modules/GET_NEW_UI/dfi-implement-details/dfi-implement-details.component';
import { DfiObservationDetailsComponent } from './modules/GET_NEW_UI/dfi-implement-details/component/dfi-observation-details/dfi-observation-details.component';
import { DocumentInLibraryComponent } from './modules/document-in-library/document-in-library.component';
import { AttachFileDialogComponent } from './modules/document-in-library/attach-file-dialog/attach-file-dialog.component';
import { DocumentInLibrarySearchComponent } from './modules/document-in-library-search/document-in-library-search.component';
import { DocumentLibraryComponent } from './modules/GET_NEW_UI/equipment-details/components/document-library/document-library.component';
import { DocumentAdjustmentAuditTrailComponent } from './modules/GET_NEW_UI/equipment-details/components/document-library/document-adjustment-audit-trail/document-adjustment-audit-trail.component';
import { DocumentLibraryService } from './modules/GET_NEW_UI/services/document-library.service';
import { ImplementModelSetupComponent } from './modules/GET_NEW_UI/implement-model-setup/implement-model-setup.component';
import { ProductImprovementProgramComponent } from './modules/ProductImprovement/product-improvement-program/product-improvement-program.component';
import { ProductImprovementProgramSearchComponent } from './modules/ProductImprovement/product-improvement-program-search/product-improvement-program-search.component';
import { ProductImprovementImplementDialogComponent } from './modules/ProductImprovement/product-improvement-implement-dialog/product-improvement-implement-dialog.component';
import { ProductImprovementForAssetComponent } from './modules/ProductImprovement/product-improvement-for-asset/product-improvement-for-asset.component';
import { ProgramImprovementService } from './modules/GET_NEW_UI/services/program-improvement.service';
import { PolicyProcedureService } from './modules/GET_NEW_UI/services/policy-procedure.service';
import { AddNewImplementAndBuildnoComponent } from './modules/GET_NEW_UI/implement-model-setup/add-new-implement-and-buildno/add-new-implement-and-buildno.component';
import { ImplementSetupComponent } from './modules/GET_NEW_UI/setup-implement/New Setup Implement/implement-setup/implement-setup.component';
import { ImplementComponentSetupComponent } from './modules/GET_NEW_UI/setup-implement/New Setup Implement/implement-component-setup/implement-component-setup.component';
import { ImplementObspointSetupComponent } from './modules/GET_NEW_UI/setup-implement/New Setup Implement/implement-obspoint-setup/implement-obspoint-setup.component';
import { InspectionAttachedDocsComponent } from './modules/GET_NEW_UI/inspection-attached-docs/inspection-attached-docs.component';
import { PipForDashboardComponent } from './modules/ProductImprovement/pip-for-dashboard/pip-for-dashboard.component';
import { WarrantyTypeSetupComponent } from './modules/warranty-type-setup/warranty-type-setup.component';
import { WarrantyStatusDialogComponent } from './modules/warranty-type-setup/warranty-status-dialog/warranty-status-dialog.component';
import { ConfirmResetDialogComponent } from './modules/document-in-library/confirm-reset-dialog/confirm-reset-dialog.component';
import { CrackCommentsDialogComponent } from './modules/GET_NEW_UI/equipment-details/components/crack-comments-dialog/crack-comments-dialog.component';
import { ObservationListCustomerComponent } from './modules/GET_NEW_UI/observation-list-customer/observation-list-customer.component';
import { ImplementsCrackViewComponent } from './modules/GET_NEW_UI/dashboard/implements-crack-view/implements-crack-view.component';
import { ImplementCrackViewDialogComponent } from './modules/GET_NEW_UI/dashboard/implements-crack-view/implement-crack-view-dialog/implement-crack-view-dialog.component';
import { AssetDetailHistoryDfiComponent } from './modules/GET_NEW_UI/dfi-implement-details/asset-detail-history-dfi/asset-detail-history-dfi.component';
import { ViewObsHistoryPhotoDialogComponent } from './modules/GET_NEW_UI/equipment-details/components/obspoint-action-histroy/view-obs-history-photo-dialog/view-obs-history-photo-dialog.component';
import { FavouriteDialogDigitalFormComponent } from './modules/GET_NEW_UI/digital-form-search/favourite-dialog-digital-form/favourite-dialog-digital-form.component';
import { DigitalFormUserAlertComponent } from './modules/GET_NEW_UI/digital-form-search/digital-form-user-alert/digital-form-user-alert.component';
import { ProductImprovmentAssetViewimageComponent } from './modules/ProductImprovement/product-improvement-for-asset/product-improvment-asset-viewimage/product-improvment-asset-viewimage.component';
import { DashboardColumnOrderDialogComponent } from './modules/GET_NEW_UI/dashboard/implement-overview/dashboard-column-order-dialog/dashboard-column-order-dialog.component';
import { CrackObspointSchematicComponent } from './modules/GET_NEW_UI/dashboard/implements-crack-view/implement-crack-view-dialog/crack-obspoint-schematic/crack-obspoint-schematic.component';
import { MakeSetupComponent } from './modules/make-setup/make-setup.component';
import { JobPositionsComponent } from './modules/safety-job-positions/job-positions.component';
import { TrainingRegisterSearchComponent } from './modules/safety-job-positions/training-register-search/training-register-search.component';
import { SchematicOpPopupEditAllComponent } from './modules/GET_NEW_UI/schematic-op-popup-edit-all/schematic-op-popup-edit-all.component';
import { CreateRopeshovelInspectionComponent } from './modules/manage-equipment/components/create-ropeshovel-inspection/create-ropeshovel-inspection.component';
import { DigitalFormReportsComponent } from './modules/GET_NEW_UI/digital-form-reports/digital-form-reports.component';
import { DeleteFormsConfirmationDialogComponent } from './modules/GET_NEW_UI/search-form-analysisreporting/delete-forms-confirmation-dialog/delete-forms-confirmation-dialog.component';
import { DeleteConfirmCheckboxDialogComponent } from './modules/GET_NEW_UI/digital-form-fill/component/delete-confirm-checkbox-dialog/delete-confirm-checkbox-dialog.component';
import { DraggableModule } from './modules/GET_NEW_UI/schemantic-op-popup/draggable.module';


//import { CreateNewWsreInspectionComponent } from './modules/inspection/create-new-wsre-inspection/create-new-wsre-inspection.component';
// import { CreateNewThermographyInspectionComponent } from './modules/Thermography/create-new-thermography-inspection/create-new-thermography-inspection.component';
// import { InspSystemComponent } from './modules/Thermography/create-new-thermography-inspection/insp-system/insp-system.component';

//Identity Import
//import { AgmCoreModule } from '@agm/core';
import { DealershipService } from './modules/IDENTITY_WEB/services/dealership.service';
import { JobsiteService } from './modules/IDENTITY_WEB/services/jobsite.service';
import { AdministrationService } from './modules/IDENTITY_WEB/administration/administration.service';
//import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { AddUserModalComponent } from './modules/IDENTITY_WEB/add-user-modal/add-user-modal.component';
import { AddCustomerModalComponent } from './modules/IDENTITY_WEB/add-customer-modal/add-customer-modal.component';
import { AddJobsiteModalComponent } from './modules/IDENTITY_WEB/add-jobsite-modal/add-jobsite-modal.component';
import { AddDealershipModalComponent } from './modules/IDENTITY_WEB/add-dealership-modal/add-dealership-modal.component';
import { EditCustomerModalComponent } from './modules/IDENTITY_WEB/edit-customer-modal/edit-customer-modal.component';
import { EditJobsiteModalComponent } from './modules/IDENTITY_WEB/edit-jobsite-modal/edit-jobsite-modal.component';
import { EditDealershipModalComponent } from './modules/IDENTITY_WEB/edit-dealership-modal/edit-dealership-modal.component';
import { AddDealershipBrandingModalComponent } from './modules/IDENTITY_WEB/add-dealership-branding-modal/add-dealership-branding-modal.component';
import { EditUserModalComponent } from './modules/IDENTITY_WEB/edit-user-modal/edit-user-modal.component';
import { EditDealershipBrandingModalComponent } from './modules/IDENTITY_WEB/edit-dealership-branding-modal/edit-dealership-branding-modal.component';
import { AssignModalComponent } from './modules/IDENTITY_WEB/assign-modal/assign-modal.component';
import { AddFormcategoryComponent } from './modules/IDENTITY_WEB/create-digital-form/components/add-formcategory/add-formcategory.component';
import { AddDealergroupModalComponent } from './modules/IDENTITY_WEB/add-dealergroup-modal/add-dealergroup-modal.component';
import { NavbarSideComponent } from './modules/IDENTITY_WEB/navbar-side/navbar-side.component';
import { SearchInspectionComponent } from './modules/GET_NEW_UI/search-inspection/search-inspection.component';
import { EmailfaxlogComponent } from './modules/GET_NEW_UI/emailfaxlog/emailfaxlog.component';
import { AdministrationComponent } from './modules/IDENTITY_WEB/administration/administration.component';
import { FilterUserTablePipe } from './modules/IDENTITY_WEB/pipes/filter-user-table.pipe';
import { FilterCustomerTablePipe } from './modules/IDENTITY_WEB/pipes/filter-customer-table.pipe';
import { FilterJobsiteTablePipe } from './modules/IDENTITY_WEB/pipes/filter-jobsite-table.pipe';
import { DecimalpointsDirective } from './modules/IDENTITY_WEB/add-jobsite-modal/decimalpoints.directive';
import { CreateDigitalFormComponent } from './modules/IDENTITY_WEB/create-digital-form/create-digital-form.component';
import { EditDigitalFormComponent } from './modules/IDENTITY_WEB/edit-digital-form/edit-digital-form.component';
import { ConfirmDialogComponentIdentity } from './modules/IDENTITY_WEB/create-digital-form/components/confirm-dialog/confirm-dialog.component';
import { NavbarTopComponentIdentity } from './modules/IDENTITY_WEB/navbar-top/navbar-top.component';
import { DigitalFormServiceIdentity } from './modules/IDENTITY_WEB/services/digital-form.service';
import { CustomerServiceIdentity } from './modules/IDENTITY_WEB/services/customer.service';
import { UserServiceIdentity } from './modules/IDENTITY_WEB/services/user.service';
import { AddThermographyAdditonalComponentComponent } from './modules/Thermography/add-thermography-additonal-component/add-thermography-additonal-component.component';
import { SearchLeavesComponent } from './modules/GET_NEW_UI/Leaves/search-leaves/search-leaves.component';
import { CreateNewLeaveComponent } from './modules/GET_NEW_UI/Leaves/create-new-leave/create-new-leave.component';
import { SafetyLeavesService } from './modules/GET_NEW_UI/services/safety-leaves.service';
import { AddPolicyProcedureComponent } from './modules/GET_NEW_UI/policy-procedure/add-policy-procedure/add-policy-procedure.component';
import { SearchPolicyProcedureComponent } from './modules/GET_NEW_UI/policy-procedure/search-policy-procedure/search-policy-procedure.component';
import { LeaveAdministrationComponent } from './modules/GET_NEW_UI/Leaves/leave-administration/leave-administration.component';
import { UpdateLeaveStatusComponent } from './modules/GET_NEW_UI/Leaves/update-leave-status/update-leave-status.component';
import { ForecastInspectionStatisticsComponent } from './modules/GET_NEW_UI/forecast-inspection-statistics/forecast-inspection-statistics.component';
import { WelcomeComponent } from './modules/GET_NEW_UI/welcome/welcome.component';
import { FilterDealerTablePipe } from './modules/IDENTITY_WEB/pipes/filter-dealer-table.pipe';
import { FilterDealerGroupTablePipe } from './modules/IDENTITY_WEB/pipes/filter-dealergroup-table.pipe';
import { ActionRecommendationRuleComponent } from './modules/Action-Recommendation/action-recommendation-rule/action-recommendation-rule.component';
import { ActionRecommendationService } from './modules/Action-Recommendation/action-recommendations.service';
import { ActionRecommendationRuleDetailComponent } from './modules/Action-Recommendation/action-recommendation-rule-detail/action-recommendation-rule-detail.component';
import { AddWsreSubcomponentComponent } from './modules/measurement-points-admin/add-wsre-subcomponent/add-wsre-subcomponent.component';
import { AdditionalComponentAnswerComponent } from './modules/interpretation/components/additional-component-answer/additional-component-answer.component';
import { SetupNumericalAdditionalobsWornLimitComponent } from './modules/inspection/add-inspection-observation-lists/setup-numerical-additionalobs-worn-limit/setup-numerical-additionalobs-worn-limit.component';
import { ViewMultipleMeasurementsComponent } from './modules/interpretation/components/view-multiple-measurements/view-multiple-measurements.component';
import { ViewFlaggedComponentInfoComponent } from './modules/interpretation/components/view-flagged-component-info/view-flagged-component-info.component';
import { AddShoeInfoComponent } from './modules/equipment-record-action/component/add-shoe-info/add-shoe-info.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TrackCareSearchComponent } from './modules/track-care-parts/track-care-search/track-care-search.component';
import { ImplementAssetDetailsComponent } from './modules/GET_NEW_UI/equipment-details/observation-details/implement-asset-details.component';
import { ObspointsUpdateLimitsComponent } from './modules/setup-models/obspoints-update-limits/obspoints-update-limits.component';
import { CommonModule } from '@angular/common';
import { ViewMblFlaggedComponentInfoComponent } from './modules/uc-inspections/view-mbl-flagged-component-info/view-mbl-flagged-component-info.component';
import { SetupComponentTypeComponent } from './setup-component-type/setup-component-type.component';
import { WsreQuickChainComponent } from './modules/wsre-quick-chain/wsre-quick-chain.component';
import { BillingDetailComponent } from './modules/track-care-parts/billing-detail/billing-detail.component';
import { ConfirmPopUpComponent } from './modules/track-care-parts/confirm-pop-up/confirm-pop-up.component';
import { RequestNewChainModelComponent } from './modules/track-care-parts/request-new-chain-model/request-new-chain-model.component';
import { BillingConfirmationPopupComponent } from './modules/track-care-parts/billing-confirmation-popup/billing-confirmation-popup.component';
import { ChangeComponentComponent } from './modules/manage-equipment/components/change-component/change-component.component';
import { COstEditPopupComponent } from './modules/manage-equipment/components/action-history/cost-edit-popup/cost-edit-popup.component';
import { SMUPMServiceComponent } from './modules/manage-equipment/components/smu-pm-service/smu-pm-service.component';
import { AddNewComponentComponent } from './modules/manage-equipment/components/add-new-component/add-new-component';
import { EquipmentOverviewComponent } from './modules/manage-equipment/components/equipment-overview/equipment-overview.component';
import { PipeModule } from './shared/pipes/pipe.module';
import { ClosepmservicepopupComponent } from './modules/manage-equipment/components/smu-pm-service/closepmservicepopup/closepmservicepopup.component';
import { DecimalLimitDirective } from './shared/directives/decimal.directive';
import { AppConfigService } from './services/app.configservice';
import { SchematicCompsMarkingComponent } from './modules/GET_NEW_UI/schematic-comps-marking-popup/schematic-comps-marking.component';
import { SchematicCompsMarkingService } from './modules/GET_NEW_UI/schematic-comps-marking-popup/schematic-comps-marking.service';
import { AvgWornCalculationPopUpComponent } from './modules/manage-equipment/avg-worn-calculation-pop-up/avg-worn-calculation-pop-up.component';
import { SchemanticCompTypePopupComponent } from './modules/GET_NEW_UI/schemantic-op-popup/schemantic-comptype-popup.component';
import { ResetPasswordDialogComponent } from '../app/shared/components/reset-password-dialog/reset-password-dialog.component';
import { ImplementsCrackViewNewComponent } from './modules/GET_NEW_UI/dashboard/implements-crack-view/implements-crack-view-new/implements-crack-view-new.component'
import { ActionEditComponent } from './modules/equipment-record-action/component/action-edit/action-edit.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { AddNewComponentValidationComponent } from './modules/manage-equipment/components/add-new-component/add-new-component-validation/add-new-component-validation';
import { ShovelGraphComponent } from './modules/manage-equipment/shovel-graph/shovel-graph.component';
import { ShovelGraphTablePopupComponent } from './modules/manage-equipment/shovel-graph/shovel-graph-table-popup/shovel-graph-table-popup.component';
//import { ComponentImageHistoryComponent } from './shared/components/component-image-history/component-image-history.component';
//import { ViewComponentTypePointsComponent } from './modules/GET_NEW_UI/inspections/new-inspection/implement-inspection-section/components/view-componenttype-points/view-componenttype-points.component';
import { AddEqualiserBarComponentComponent } from './modules/manage-equipment/components/add-new-component/add-equaliser-bar-component/add-equaliser-bar-component';
import { InspectionHistoryTabularComponent } from './modules/manage-equipment/components/inspection-history/inspection-history-tabular.component';

FusionChartsModule.fcRoot(FusionCharts, Charts, FusionTheme);

FusionCharts.options['creditLabel'] = false;

export function initializeApp(appConfig: AppConfigService) {
  return () => appConfig.loadConfig();
}


//export function sessionCheckFactory(
//  http: HttpClient,
//  appService: AppService
//) {
//  return () => {
//    const baseUrl = appService.getBaseURL();
//    //console.log("baseUrl sessionCheckFactory: ", baseUrl);
//    return http
//      .get(`${baseUrl}api/auth/ping`, { withCredentials: true })
//      .toPromise().then((response) => {
//        // if API explicitly returns false
//        if (response === false) {
//          const returnUrl = encodeURIComponent(
//            window.location.pathname + window.location.search
//          );

//          window.location.href =
//            `${baseUrl}Account/Login?ReturnUrl=${returnUrl}`;
//        }

//        return response;
//      })
//      .catch((err) => {
//        if (err.status === 401) {
//          const returnUrl = encodeURIComponent(
//            window.location.pathname + window.location.search
//          );

//          window.location.href =
//            `${baseUrl}Account/Login?ReturnUrl=${returnUrl}`;
//        }

//        return Promise.reject(err);
//      });
//  };
//}
export function sessionCheckFactory(
  http: HttpClient,
  appService: AppService
) {
  return () => {
    const baseUrl = appService.getBaseURL();
    const currentPath = window.location.pathname.toLowerCase();

    const publicMvcPages = [
      "/account/signin",
      "/account/forgotpassword",
      "/account/forgotpasswordconfirmation",
      "/account/forgotusername",
      "/account/forgotusernameconfirmation",
      "/account/resetpassword",
      "/account/resetpasswordconfirmation",
      "/account/resetusername",
      "/account/resetusernameconfirmation",
      "/account/verifycode",
      "/account/disclaimer",
      "/account/sendcode",
      "/account/suspended",
      "/account/register",
      "/account/promotion",
      "/account/confirmemail"
    ];

    const isPublicMvcPage = publicMvcPages.some(path =>
      currentPath.startsWith(path.toLowerCase())
    );

    console.log("Current path:", currentPath);
    console.log("Public MVC page:", isPublicMvcPage);

    if (isPublicMvcPage) {
      console.log("Skipping Angular session check");
      return Promise.resolve(true);
    }

    return http
      .get<boolean>(`${baseUrl}api/auth/ping`, {
        withCredentials: true
      })
      .toPromise()
      .then((response) => {
        if (!response) {
          const returnUrl = encodeURIComponent(
            window.location.pathname + window.location.search
          );

          window.location.href =
            `${baseUrl}Account/SignIn?ReturnUrl=${returnUrl}`;
        }

        return response;
      })
      .catch((err) => {
        if (err.status === 401) {
          const returnUrl = encodeURIComponent(
            window.location.pathname + window.location.search
          );

          window.location.replace(
            `${baseUrl}Account/SignIn?ReturnUrl=${returnUrl}`
          );

          return Promise.resolve();
        }

        return Promise.reject(err);
      });
  };
}



@NgModule({
  declarations: [
    AppComponent,
    UCInspectionsComponent,
    RedirectComponent,
    ManageEquipmentComponent,
    FavoriteDialog,
    SetupUndercarriageComponent,
    SetupUndercarriageInInventory,
    SetupUndercarriageOnEquipment,
    ChangeJobsiteComponent,
    EditPhotoComponent,
    EditPhotoTestComponent,
    UpdateMeterComponent,
    ChangeMeterUnitComponent,
    InspectionPlannerComponent,
    UpdateInspectionForecastingComponent,
    AboutPopupComponent,
    CreateNewTemperatureInspectionComponent,
    InterpTemperatureInspectionComponent,
    AddTemInspectionCommentComponent,
    AddTempInspectionDetailsCommentComponent,
    UpdateAmbienttempInspectionDateDialogComponent,
    TemperatureInspectionHistoryDialogComponent,
    SetupUndercarraigeActionComponent,
    InspectionHistoryComponent,
    InspectionHistoryTabularComponent,
    CreateDialogThermographyComponent,
    AddThermographyInspectionDetailsCommentComponent,
    ManageCustomEvalComponent,
    CustomEvalDeleteConfirmComponent,
    ActionHistoryComponent,
    TrackFrameConfigurationComponent,
    FrameConfigWarningComponent,
    WsreSendReportComponent,
    SetupTrainingTypesComponent,
    AddTrainingCategoryComponent,
    SetupTrainingComponent,
    AddSlideComponent,
    SetupTrainingQuestionsComponent,
    AddTrainingQuestionComponent,
    ManageTrainingActivityComponent,
    StartTrainingDetailsComponent,
    SendTrainingPopupComponent,
    TrainingSessionComponent,
    InspectionNoteComponent,
    ManageComponentCriticalityComponent,
    ComponentLifePerformanceComponent,
    ObservationpointHistoryComponent,
    ConfirmDialogComponent,
    EquipmentRecordActionComponent,
    CustomerContactComponent,
    AddNewUserClComponent,
    AddNewUserElComponent,
    AddNewUserJslComponent,
    CalculateActionWornComponent,
    JobrolePermissionsComponent,
    ActionCommentComponent,
    EditSystemSerialNumberComponent,
    SetupEquipmentTestComponent,
    //CreateNewWsreInspectionComponent,
    // CreateNewThermographyInspectionComponent,
    // InspSystemComponent,
    //GETUI_NEW
    DashboardComponentGET,
    NavbarTopComponent,
    NavbarSide,
    BreadCrumbTopComponent,
    RedirectComponent,
    ImplementDetailsComponent,
    ImplementStatusModalComponent,
    AttachImplementModalComponent,
    RemoveImplementModalComponent,
    RecordRepairModalComponent,
    RecordReplaceModalComponent,
    ChangeImplementJobsiteModalComponent,
    RemoveImplementModalComponent,
    ImplementTemplateSetupComponent,
    AddRepairerWorkshopModalComponent,
    FilterPipe,
    ImplementTemplatesComponent,
    SchematicViewComponent,
    CarouselComponent,
    CarouselItemDirective,
    CarouselItemElement,
    GETSetupEquipmentComponent,
    SetupImplementComponent,
    ApplySelectionComponent,
    DraggableSchematicComponent,
    GETDeleteConfirmationDialogComponent,
    PreferencesComponent,
    CopyImplementDialogComponent,
    AddObservationPointComponent,
    DialogDraggableTitleDirective,
    SchemanticOpPopupComponent,
    SchemanticCompTypePopupComponent,
    SchematicCompsMarkingComponent,
    ImplementsByEquipmentComponent,
    SearchPanelComponent,
    FavouriteDialogComponent,
    CopyImplementComponent,
    EquipmentDetailsComponent,
    ObservationDetailsComponent,
    ImplementAssetDetailsComponent,
    ImplementDetailsHeaderComponent,
    SchematicObservationPointsComponent,
    GETUpdateMeterComponent,
    GETChangeJobsiteComponent,
    ImplementActionComponent,
    GETViewPhotoComponent,
    GETEditPhotoComponent,

    GETChangeMeterUnitComponent,
    ImplementActionComponent,
    MoveToInventoryComponent,
    ImplementSortComponent,
    SelectionNewImplementComponent,
    PerformInspectionComponent,
    ImplementOverviewComponent,
    ImplementRebuildDialogComponent,
    ImplementRebuildCompleteDialogComponent,
    ImplementTargetsUpdateComponent,
    ImplementHistoryComponent,
    ImplementLocationHistoryComponent,
    GETInspectionPlannerComponent,
    DigitalFormSearchComponent,
    DigitalFormFillComponent,
    DigitalFormCategorylistComponent,
    EditPhotoDigitalComponent,
    CopyDigitaFormComponent,
    SelectEquipmentComponent,
    DigitalFormSearchAdminstartionComponent,
    DigitalFormSectionQuestionsComponent,
    ClearFlagDialogComponent,
    FlagCommentComponent,
    GETAboutPopupComponent,
    NormalQuestionHistoryComponent,
    StructuralQuestionHistoryComponent,
    GETFecrImplementRebuildDetailsComponent,
    FecrImplementDetailsHeaderComponent,
    FecrObservationDetailsComponent,
    AddFecrRecommendationComponent,
    FECRDashboardComponent,
    FecrSearchPanelComponent,
    FecrImplmentSearchResultComponent,
    FecrObservationHistoryComponent,
    MoveImplementToRepairerComponent,
    FecrMovetoInventoryComponent,
    FecrProjectContactDialogComponent,
    FecrPartsListComponent,
    //safet ui
    // ListBoxComponent,
    //ButtonComponent,
    AboutComponent,
    HomeComponent,
    LoginComponent,
    SelectAFormComponent,
    UploadFormComponent,
    EnterSafetyInspectionDialogComponent,
    SearchFormAnalysisreportingComponent,
    SearchSafetyInspectionComponent,
    PerformInductionComponent,
    SearchInductionComponent,
    SetupInductionSlidesComponent,
    SafetyInductionSetupComponent,
    ConfigSetupDepartmentComponent,
    ConfigSetupFormsComponent,
    ConfigSetupChecklistComponent,
    ConfigSetupIncidentComponent,
    ConfigAddTakeComponent,
    ConfigAddToolboxTalkComponent,
    ConfigAddMontlyDashbrdMessageComponent,
    ConfigViewEditMonHrsComponent,
    ConfigSetupInductionandSectionsComponent,
    SetupInductionQuestionComponent,
    OnBoardingSetupInductionQuestionComponent,
    EditSetupInductionQuestionComponent,
    AnswerSetupInductionQuestionComponent,
    EditSetupDepComponent,
    EditWorkareaDialogComponent,
    AddWorkareaDialogComponent,
    AddDepartmentDialogComponent,
    AddQuestionInducComponent,
    ConfigSetupChecklistAddNewCategoryDialogComponent,
    MonthlyAlertDialogComponent,
    ConfigSetupChecklistAddNewQuestionDialogComponent,
    ConfigSetupChecklistEditCategoryDialoglogComponent,
    AddInductionTypesComponent,
    DialogAddSectionComponent,
    AddInductionQuestionComponent,
    DialogAddSlideComponent,
    DigitalFormNewInspectionComponent,
    ChangeCrackStatusComponent,
    InventoryOrWsreDialogComponent,
    DeleteConfirmDigilatFormDialogComponent,
    DialogFindAttendeeComponent,
    DialogAddAttendeeComponent,
    StartInductionComponent,
    DialogEditDetailsComponent,
    DialogAddFormComponent,
    CreateSafetyDigitalFormComponent,
    StartInductionComponent,
    DialogAddQuestionComponent,
    DialogSetupAnswersComponent,
    SafetyObservationDashboardComponent,
    SafetyIndicatorsComponent,
    SafetyGeneralDashboardComponent,
    EnterSafetyInspectionDashboardComponent,
    AddCommentDialogComponent,
    AddImageDialogComponent,
    ContractorsInvolvedDialogComponent,
    PersonsInvolvedDialogComponent,
    EditWorkAreaDepartmentDialogComponent,
    DealergroupBrandingComponent,
    AddIncidenttypeDialogComponent,
    EditIncidentTtypeDialogComponent,
    ConfigSetupChecklistEditQuestionDialogComponent,
    UploadDigitalFormsComponent,
    EditImageDialogComponent,
    ConfirmActionBackInComponent,
    EditDigitalFormsComponent,
    EditImageDialogEditformsComponent,
    UploadFormEditComponent,
    DialogAddFormCatrgoryComponent,
    WsreSearchOnEquipmentComponent,
    EditCommentDialogComponent,
    DigitalEditCommentDialogComponent,
    SetupWornLimitComponent,
    UserContactComponent,
    AddNewUserUcComponent,
    AddNewJobsiteUcComponent,
    AddNewEquipmentUcComponent,
    InspectionReportingModuleComponent,
    ReportContactDialogComponent,
    AddAdditionalAttachmentComponent,
    FormActivitiesComponent,
    WsreQuickIdlerComponent,
    UscoDataComparisonDialogComponent,
    EquipmentStatusPopupComponent,
    CustomCommentPopupComponent,
    ComponentActionHistoryComponent,
    SendHirereportDialogComponent,
    ComponentHistroyDialogComponent,
    AddCrackObsPointDialogComponent,
    AddAdditionalAttachmentGETComponent,
    ObspointActionHistroyComponent,
    ImplementDetailsHistoryComponent,
    SchemanticOpPopupEditComponent,
    IncidentDialogComponent,
    IncidentLtiDialogComponent,
    IncidentMtiDialodComponent,
    HomeNewComponent,
    HomescreenSafetyComponent,
    BucketperformanceAgainstBudgetWidgetComponent,
    FecrPrePostShipmentObservationListComponent,
    FecrAddNewPrepostShipmentObservationComponent,
    CopyImplmentAdvancedComponent,
    ConfirmationMessageDeleteormsComponent,
    //FecrNewPrePostShipmentInspectionComponent,
    MeasurementPointsDetailComponent,
    WsreQuickFrameComponent,
    WsreQuickChainComponent,
    DfiImplementDetailsComponent,
    DfiObservationDetailsComponent,
    DocumentInLibraryComponent,
    AttachFileDialogComponent,
    DocumentInLibrarySearchComponent,
    DocumentLibraryComponent,
    DocumentAdjustmentAuditTrailComponent,
    ImplementModelSetupComponent,
    ImplementSetupComponent,
    ImplementComponentSetupComponent,
    ImplementObspointSetupComponent,
    ProductImprovementProgramComponent,
    ProductImprovementProgramSearchComponent,
    ProductImprovementImplementDialogComponent,
    ProductImprovementForAssetComponent,
    AddNewImplementAndBuildnoComponent,
    InspectionAttachedDocsComponent,
    PipForDashboardComponent,
    WarrantyTypeSetupComponent,
    WarrantyStatusDialogComponent,
    ConfirmResetDialogComponent,
    CrackCommentsDialogComponent,
    ObservationListCustomerComponent,
    ImplementsCrackViewComponent,
    ImplementCrackViewDialogComponent,
    AssetDetailHistoryDfiComponent,
    ViewObsHistoryPhotoDialogComponent,
    FavouriteDialogDigitalFormComponent,
    DigitalFormUserAlertComponent,
    ProductImprovmentAssetViewimageComponent,
    DashboardColumnOrderDialogComponent,
    CrackObspointSchematicComponent,
    MakeSetupComponent,
    JobPositionsComponent,
    TrainingRegisterSearchComponent,
    SchematicOpPopupEditAllComponent,
    CreateRopeshovelInspectionComponent,
    DigitalFormReportsComponent,
    DeleteFormsConfirmationDialogComponent,
    DeleteConfirmCheckboxDialogComponent,
    //Identity
    NavbarSideComponent,
    AdministrationComponent,
    FilterUserTablePipe,
    FilterCustomerTablePipe,
    AddUserModalComponent,
    AddCustomerModalComponent,
    AddJobsiteModalComponent,
    SearchInspectionComponent,
    EmailfaxlogComponent,
    FilterJobsiteTablePipe,
    FilterDealerGroupTablePipe,
    FilterDealerTablePipe,
    AddDealershipModalComponent,
    EditCustomerModalComponent,
    EditJobsiteModalComponent,
    EditDealershipModalComponent,
    AddDealershipBrandingModalComponent,
    EditUserModalComponent,
    EditDealershipBrandingModalComponent,
    AssignModalComponent,
    DecimalpointsDirective,
    CreateDigitalFormComponent,
    AddFormcategoryComponent,
    EditDigitalFormComponent,
    RedirectComponent,
    ConfirmDialogComponentIdentity,
    AddDealergroupModalComponent,
    NavbarTopComponentIdentity,
    AddThermographyAdditonalComponentComponent,
    SearchLeavesComponent,
    CreateNewLeaveComponent,
    AddPolicyProcedureComponent,
    SearchPolicyProcedureComponent,
    LeaveAdministrationComponent,
    UpdateLeaveStatusComponent,
    ForecastInspectionStatisticsComponent,
    WelcomeComponent,
    ActionRecommendationRuleComponent,
    ActionRecommendationRuleDetailComponent,
    AdditionalComponentAnswerComponent,
    SetupNumericalAdditionalobsWornLimitComponent,
    ViewMultipleMeasurementsComponent,
    ViewFlaggedComponentInfoComponent,
    AddShoeInfoComponent,
    ObspointsUpdateLimitsComponent,
    AddShoeInfoComponent,
    SetupComponentTypeComponent,
    ViewMblFlaggedComponentInfoComponent,
    TrackCareSearchComponent,
    RequestNewChainModelComponent,
    BillingDetailComponent,
    ConfirmPopUpComponent,
    BillingConfirmationPopupComponent,
    ChangeComponentComponent,
    COstEditPopupComponent,
    SMUPMServiceComponent,
    AddNewComponentComponent,
    EquipmentOverviewComponent,
    ClosepmservicepopupComponent,
    DecimalLimitDirective,
    AvgWornCalculationPopUpComponent,
    ResetPasswordDialogComponent,
    ImplementsCrackViewNewComponent,
    ActionEditComponent,
    AddNewComponentValidationComponent,
    ShovelGraphComponent,
    ShovelGraphTablePopupComponent,
    //ViewComponentTypePointsComponent,
    //ComponentImageHistoryButtonComponent
    //ComponentImageHistoryComponent
    AddEqualiserBarComponentComponent
  ],
  imports: [
    routing,
    BrowserModule,
    HttpClientModule,
    DashboardModule.forRoot(),
    FormsModule,
    MaterialModule,
    BrowserAnimationsModule,
    EquipmentActionsModule.forRoot(),
    ReactiveFormsModule,
    SimpleNotificationsModule.forRoot(),
    WsreModule,
    SharedModule,
    InterpretationModule,
    SetupEquipmentModule,
    RopeShovelModule,
    PreferencesModule,
    TranslateModule,
    InspectionModule,
    MeasurementPointsAdminModule,
    InventoryModule,
    ActionModule,
    ManageComponentsModule,
    ComponentForecastModule,
    SetupFamilyModule,
    SetupModelsModule,
    CustomerNotesModule,
    FusionChartsModule.forRoot(FusionCharts, Charts),
    ThermorgraphyInspectionModule,
    GETWidgetsModule,
    DraggableModule,
    //GET
    routing,
    BrowserModule,
    HttpClientModule,
    FormsModule,
    MaterialModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatDialogModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    MatChipsModule,
    UiSwitchModule,
    GETInspectionModule,
    MatButtonToggleModule,
    GETSharedModule,
    AngularDualListBoxModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatToolbarModule,
    MatListModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTabsModule,
    FormsModule, ReactiveFormsModule,
    HttpClientModule,
    MatTableModule,
    MatMenuModule,
    MatGridListModule,
    MatDatepickerModule,
    MatNativeDateModule,
    BrowserModule,
    routing,
    HttpClientModule,
    BrowserAnimationsModule,
    MatTabsModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatSnackBarModule,
    MatRadioModule,
    //AngularMultiSelectModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatSelectModule,
    MatFormFieldModule,
    MatListModule,
    CommonModule,
    SimpleNotificationsModule.forRoot(),
    RouterModule.forRoot([], { relativeLinkResolution: 'legacy' }),
    PipeModule,
    ColorPickerModule
    //   AgmCoreModule.forRoot({
    //     apiKey: 'AIzaSyDuVToNzv5ZqsVTlAklZciwEbXpiIsY0sU',
    //     libraries: ['places']
    // }),
  ],
  providers: [

    //{
    //  provide: HTTP_INTERCEPTORS,
    //  useClass: AuthInterceptor,
    //  multi: true
    //},

    {
      provide: APP_INITIALIZER,
      useFactory: sessionCheckFactory,
      deps: [HttpClient, AppService],
      multi: true
    },

    AppService,
    UCInspectionsService,
    {
      provide: UrlSerializer,
      useClass: LowerCaseUrlSerializer
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfigService],
      multi: true
    },
    SetupUndercarriageService,
    LoadingService,
    ManageEquipmentService,
    BarGraphService,
    TranslateService,
    UserService,
    EmailFaxLogService,
    MeasurementPonitsService,
    CustomErrorHandlers,
    TemperatureInspectionService,
    CustomEvalService,
    TrainingService,
    EquipmentRecordActionService,
    CustomerContactService,
    UcSetupWornLimitService,
    //GET
    ImplementDetailsService,
    ImplementRebuildService,
    ChangeImplementJobsiteModalService,
    AttachImplementModalService,
    RemoveImplementModalService,
    ImplementStatusModalService,
    GETInventoryService,
    CustomerService,
    EquipmentService,
    ImplementTemplateService,
    UserService,
    SchematicViewService,
    GETSetupEquipmentService,
    SetupImplementService,
    GETDashboardService,
    GETPreferencesService,
    FavouriteDialogService,
    EquipmentDetailsService,
    MatDialog,
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: [] },
    LoadingService,
    DigitalFormService,
    FrontEndComponetService,
    SafetyConfigService,
    SafetyInductionService,
    SafetyGeneraldashboardService,
    SafetyFormsService,
    InterpretationreportService,
    DocumentLibraryService,
    ProgramImprovementService,
    PolicyProcedureService,
    DealershipService,
    CustomerServiceIdentity,
    JobsiteService,
    AdministrationService,
    DigitalFormServiceIdentity,
    UserServiceIdentity,
    SafetyLeavesService,
    ActionRecommendationService,
    AppConfigService,
    SchematicCompsMarkingService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
